import React from "react";
import { Link } from "react-router-dom";
import "../Homecontact/Homecontact.css";
import homecontactbanner from "../Assets/homecontact.jpeg";
import Button from "react-bootstrap/Button";

const Homecontact = () => {
  return (
    <section className="homecontact-section">
      <div className="homecontact-container">
        <img src={homecontactbanner} alt="" />
        <div className="homecontact-container-content text-center ">
          <h5>Make Your Dream App Come True</h5>
          <h1>Cornerstone Technologies</h1>
          <p className="px-5">
            The Cornerstone development team truly stood out. Their deep
            understanding of your project's intricacies led to invaluable
            recommendations for improvement. Their unwavering responsiveness to
            your emails and calls, irrespective of the hour, was remarkable.
            Thanks to their dedication, you now have a robust business solution
            that has transformed your operations for the better.
          </p>
          <Link to={"/contactus"}>
            <Button className=" rounded-5 px-5" variant="warning">
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Homecontact;
